import * as React from 'react';

function SvgMyProfile(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 16" fill="#8a2be2" {...props}>
      <path d="M6.828 8.377c2.352 0 4.267-1.876 4.267-4.182 0-2.306-1.915-4.182-4.267-4.182-2.353 0-4.267 1.876-4.267 4.182 0 2.306 1.914 4.182 4.267 4.182zm-1.637.766c-2.971 0-5.19 2.004-5.19 4.914v.313c0 1.52 2.378 1.52 5.388 1.52h3.197c2.891 0 5.388 0 5.388-1.52v-.313c0-2.91-2.219-4.914-5.19-4.914H5.191z" />
    </svg>
  );
}

export default SvgMyProfile;
